import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const Container = styled.section`
  display: grid;
  grid-column-gap: ${pxToRem(30)};
  grid-template-columns: 100%;
  width: 100%;
  height: 100%;

  h2 {
    order: -2;
  }
`;
